
import { useEffect, useState, } from "react";
import api from '../../../../services/api';
import { InputBase } from "@mui/material";
import HeaderSession from "../../../../utils/headerSession";
import ListaExpediente from "./listaExpediente";
import { useSearchParams } from "react-router-dom";


export default function SaidasExpediente() {
    const [entradas, setEntradas] = useState('')
    const [configLista, setConfigLista] = useState('')
    const [perPage, setPerPage] = useState(50)
    const [filter, setFilter] = useState('')
    const [status, setStatus] = useState('Finalizado')
    const [searchParams] = useSearchParams();
    const [page, setPage] = useState(searchParams.get("page"));
    const [dataInicio, setDataInicio] = useState("");
    const [dataFim, setDataFim] = useState("");
    const [documento, setDocumento] = useState('');

    useEffect(() => {
        setEntradas('')

        api.get(`/expedientes?status=${status}&dataInicio=${dataInicio}&dataFim=${dataFim}&tipoDocumentoId=${documento}&page=${page}&perPage=${perPage}`)
            .then(response => {
                // console.log(response)
                setEntradas(response.data.expedientes);
                setFilter(response.data.expedientes);
                setConfigLista(response.data);
            }).catch(err => '')
    }, [page, perPage, status, dataInicio, dataFim, documento])

    const filtraentradas = (valor) => {
        setEntradas(filter.filter((espedienteGeral) => (espedienteGeral?.nome?.toLowerCase().includes(valor.toLowerCase()))))
    }

    return (
        <div>
            <HeaderSession title={'EXPEDIENTE / SAÍDAS'} />

            <div style={{ display: 'flex', marginBottom: 20 }}>
                <InputBase
                    style={{ width: '100%', border: '1px solid #85287e', borderRadius: 5, paddingLeft: 20 }}
                    sx={{ ml: 1, flex: 1 }}
                    autoFocus
                    placeholder="Filtro"
                    inputProps={{ 'aria-label': 'Filtrar lista' }}
                    onChange={(e) => { filtraentradas(e.target.value) }}
                />
            </div>

            <ListaExpediente
                expedientes={entradas}
                setPage={setPage}
                configLista={configLista}
                setPerPage={setPerPage}
                page={page}
                setDataInicio={setDataInicio}
                setDataFim={setDataFim}
                dataInicio={dataInicio}
                dataFim={dataFim}
                setDocumento={setDocumento}
                filtraentradas={filtraentradas}
            />
        </div>
    )
}
